export enum UserStatus {
    Inactive = 0,
    Active = 1
}